import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const CopyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const CloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: ${({ theme }) => theme.colors.neutralW90};
  background: transparent;
  border: 0;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
    flex: 0 0 auto;
  }
`

export const Title = styled.h2`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.neutralW90};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`

export const BodyText = styled.p`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.neutralW70};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const ActionButton = styled(Button)`
  && {
    width: 100%;
    height: 36px;
    min-height: 36px;
    padding: 6px 16px;
    font-size: 14px;
    line-height: 20px;
  }
`
